import stickyfill from 'stickyfilljs';
import BaseBehavior from '../../../framework/base/base';
import { debounce } from '../../../shared/utilities/debounce';
import { screenSmallerThan } from '../../../shared/utilities/screenSize';

export default class StickyBase extends BaseBehavior {
	constructor(element) {
		super(element);
		// don't run behavior for mobile as glossary bar doesn't show on mobile
		if (window.getComputedStyle(this.element).getPropertyValue('display') === 'none') return;

		if (
			(element.dataset.component === 'onpagenav' && element.dataset.sticky === 'true') ||
			element.dataset.component === 'glossary'
		) {
			this.element.style.top = this.calculateStickyTop('down') + 'px';
			this.subscribe('cookie/height/change', () => {
				this.element.style.top = this.calculateStickyTop('down') + 'px';
				stickyfill.refreshAll();
			});
			this.stickNavigation(stickyfill);
			this.detectScroll();
		}
	}

	stickNavigation(stickyJS) {
		stickyJS.addOne(this.element);
		stickyJS.forceSticky();
	}

	/**
	 * This function controls the theme changing of OnPageNav
	 * based on the scrolling of the page
	 */
	detectScroll() {
		const megaNav = document.querySelector('.v2-nav');
		const navigation = document.querySelector('.header__nav');

		const handleHorizontalScrollDebounced = debounce(() => {
			const { sessionStorage } = window;
			sessionStorage?.removeItem('IsMobileNavigationOpen');
			if (this.initialTop === null) {
				this.initialTop = this.element.style.top;
			}
			const position = window.getComputedStyle(this.element).getPropertyValue('position');
			if (position === 'fixed') {
				if ((megaNav && !megaNav.classList.contains('headroom--pinned')) || navigation) {
					this.element.style.top = this.calculateStickyTop('down') + 'px';
				} else {
					this.calculateStickyTop('up');
				}
				this.publish('position/updated', { value: 'value' });
				if (screenSmallerThan('sm')) {
					this.publish('collapse/navigation-mobile');
				}
				// send event here
				// this.isDesktop && this.applyThemeSettings(this.themeSettings, 'value');
			} else if (position === 'absolute') {
				this.calculateStickyTop('clear');
				this.publish('position/updated', { value: 'default' });
				// send event here
				// this.isDesktop && this.applyThemeSettings(this.themeSettings, 'default');
			}
		}, 1).bind(this);

		window.addEventListener('scroll', handleHorizontalScrollDebounced);
	}

	/**
	 * This function calculates the updated top value of OnPageNav/glossary section
	 * based on Cookie disclaimer(if present), Nav Top and Nav Root sections
	 * Param is the direction of scrolling
	 */
	calculateStickyTop(direction) {
		if (direction === 'clear') {
			this.element.style.transform = 'translateY(0px)';
			return false;
		}

		const cookieDisclaimer = document.querySelector('.v2-cookie-disclaimer--top');
		const cookieDisclaimerHeight = cookieDisclaimer ? cookieDisclaimer.offsetHeight : 0;
		const navHeight = document.querySelector('.header__nav')
			? this.navigationHeight(direction)
			: this.megaNavHeight(direction);
		// consider ESMA and cookie disc height too
		return navHeight + cookieDisclaimerHeight;
	}

	megaNavHeight(direction) {
		const navContainer = document.querySelector('header.v2-nav');
		const navRoot = navContainer && navContainer.querySelector('.v2-nav__root');
		const navTop = navContainer && navContainer.querySelector('.v2-nav__top');

		let navRootHeight = navRoot ? navRoot.offsetHeight : 0;
		if (direction === 'down') {
			this.element.style.transform = 'translateY(0px)';
			if (window.innerWidth < 1200) {
				navRootHeight = 0;
			}
		}
		const finalHeight = navRootHeight;
		if (direction === 'up') {
			let height = navTop ? navTop.offsetHeight : 0;
			if (window.innerWidth < 1200) {
				height += navRootHeight;
			}
			this.element.style.transform = 'translateY(' + height + 'px)';
			return false;
		}
		return finalHeight;
	}

	navigationHeight(direction) {
		const navContainer = document.querySelector('.header__nav');
		const finalHeight = navContainer.getBoundingClientRect().height;
		if (direction === 'down') {
			this.element.style.transform = 'translateY(0px)';
		}
		if (direction === 'up') {
			this.element.style.transform = `translateY(${finalHeight}px)`;
		}

		return finalHeight;
	}
}
